/* eslint-env browser */
const findItemInView = (element: HTMLDivElement) => {
  if (!element) return false;

  const rect = element.getBoundingClientRect();
  const result = !(rect.left >= 0 && rect.right <= window.innerWidth);
  return result;
};

const findFirstItemOutOfView = (elements: HTMLDivElement[]) => {
  let firstItemInView;
  for (let i = 0; i < elements.length; i += 1) {
    const isInView = !findItemInView(elements[i]);
    if (isInView) {
      firstItemInView = i;
      break;
    }
  }
  return firstItemInView;
};

const findActiveItemByPathName = (activePath: string, domItems: any[], items: any[]) => {
  let activeItem;
  items.map((item, index) => {
    const pathname = item.link;
    if (pathname === activePath) {
      activeItem = domItems[index];
      return true;
    }
    return false;
  });
  return activeItem;
};

export { findFirstItemOutOfView, findItemInView, findActiveItemByPathName };
